import { render, staticRenderFns } from "./report-case.vue?vue&type=template&id=7b5f41c2&"
import script from "./report-case.vue?vue&type=script&lang=js&"
export * from "./report-case.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports